export default (params) => ({
  trigger: {
    name: 'shopping_cart_dropdown.select_shopping_cart',
    params: params,
  },
  config: {
    schema: {
      content: {
        enum: [
          'title',
          'order_button',
          'change_cart_link',
          'icon',
        ],
      },
      sub_feature: {
        enum: [
          'header',
          'bottom_navigation',
        ],
      },
    },
    event: {
      name: 'select_content',
    },
  },
});
